import styled from 'styled-components';

export const CarvanaCareDetailsWrapper = styled.div`
  color: var(--cvna-color-grey-5);
`;

export const CarvanaCareLogo = styled.div`
  display: flex;
  align-items: flex-start;
  margin-right: 16px;
`;

export const WarrantyDescription = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--cvna-color-grey-5);
`;

export const AnchorElement = styled.button`
  background: transparent;
  border-color: transparent;
  text-decoration: underline;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  padding: 0;
  margin: 0;
  color: var(--cvna-color-blue-2);
  text-decoration: underline;
  display: inline-block;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }

  &:focus {
    border-color: transparent;
    outline-color: transparent;
  }
`;

export const ListWrapper = styled.ul`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding-left: 24px;
  margin: 4px 0 16px;
  list-style: none;
`;

export const ListItem = styled.li`
  margin-top: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  position: relative;

  &::before {
    content: '•';
    color: #183558;
    font-weight: normal;
    display: inline-block;
    width: 18px;
    margin-left: -18px;
    text-align: left;
    font-size: 20px;
  }
`;

export const TelephoneLink = styled.a`
  color: var(--cvna-color-blue-2);
  text-decoration: underline;

  &:hover {
    text-decoration: none;
    color: var(--cvna-color-blue-2);
  }
`;

export const Paragraph = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 0;
`;
